import ChatBox from "../Components/ChatBox";
import SendMessage from "../Components/SendMessage";

const Chat = () => {
  return (
    <>
      <ChatBox />
      <SendMessage />
    </>
  );
};

export default Chat;
